import React, { forwardRef, Ref } from 'react';

import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';

import Link, { LinkProps } from 'next/link';

type LinkRef = HTMLAnchorElement;
type NextLinkProps = Omit<MuiLinkProps, 'href' | 'classes'> & Pick<LinkProps, 'href' | 'as' | 'prefetch' | 'passHref'>;

export const NextMuiLink = forwardRef<LinkRef, NextLinkProps>(
  ({ href, as, prefetch, ...props }: LinkProps, ref: Ref<LinkRef>) => (
    <Link href={href} as={as} prefetch={prefetch}>
      <MuiLink component="span" {...props} />
    </Link>
  )
);
